export const formatDate = (date: Date, format: string) => {
	format = format.replace(/yyyy/g, String(date.getFullYear()));
	format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
	format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
	format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
	format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
	format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
	format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
	return format;
};

export const DATE = 'yyyy-MM-dd';
export const DATE_TIME = 'yyyy-MM-dd HH:mm:ss';
export const NEWS_DATE = 'yyyy.MM.dd';
const BIRTH = 'yyyy年　MM月　dd日';

/**
 * DBから取得した文字列型の日付をyyyy年MM月dd日形式の文字列にして返却する
 * @params str DBから取得した文字列型の日付
 * @returns yyyy年MM月dd日形式の文字列
 */
export const formatBirthDate = (str: string) => {
	if (!str) {
		return '　年　月　日';
	}
	const date = new Date(str);
	let format = BIRTH;
	format = format.replace(/yyyy/g, String(date.getFullYear()));
	format = format.replace(/MM/g, String(date.getMonth() + 1));
	format = format.replace(/dd/g, String(date.getDate()));
	return format;
};
